export default __webpack_public_path__ + "static/media/cppsecrets.84bdedf0.png";